"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstanceProps = getInstanceProps;
exports.isEmpty = isEmpty;
exports.isObject = isObject;
exports.omit = omit;
exports.shallowEquals = shallowEquals;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Get all getter props from a class instance
 * @param instance
 */
function getInstanceProps(instance) {
  var prototype = Object.getPrototypeOf(instance);
  var descriptors = getDescriptors(prototype);
  var getters = Object.keys(descriptors).filter(function (descriptorKey) {
    return !!descriptors[descriptorKey].get;
  });
  var result = getters.reduce(function (accum, current) {
    return _objectSpread(_objectSpread({}, accum), {}, (0, _defineProperty2.default)({}, current, instance[current]));
  }, {});
  return result;
}
function getDescriptors(prototype) {
  var descriptors = Object.getOwnPropertyDescriptors(prototype);
  var extendingPrototype = Object.getPrototypeOf(prototype);
  if (extendingPrototype !== Object.prototype) {
    return _objectSpread(_objectSpread({}, descriptors), getDescriptors(extendingPrototype));
  }
  return descriptors;
}
function isObject(item) {
  return item && (0, _typeof2.default)(item) === 'object' && !Array.isArray(item);
}

/**
 * Returns true if object is empty
 * @param object
 */
function isEmpty(object) {
  if (isObject(object)) {
    return Object.keys(object).length === 0;
  }
  if (Array.isArray(object)) {
    return object.length === 0;
  }
  return false;
}
function omit(object) {
  if (!isObject(object)) {
    throw new Error('`object` param must be an object.');
  }
  var result = _objectSpread({}, object);
  for (var _len = arguments.length, keysToOmit = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }
  keysToOmit.forEach(function (key) {
    return delete result[key];
  });
  return result;
}

/**
 * Compare objects.
 * @param ...objects
 */
function shallowEquals() {
  for (var _len2 = arguments.length, objects = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    objects[_key2] = arguments[_key2];
  }
  if (!objects.length || objects.length === 1) {
    return true;
  }
  var firstObject = objects[0];
  var otherObjects = objects.slice(1);
  if (otherObjects.every(function (obj) {
    return firstObject === obj;
  })) {
    return true;
  }
  if (!firstObject) {
    return false;
  }
  return otherObjects.every(function (obj) {
    if (firstObject === obj) {
      return true;
    }
    if ((0, _typeof2.default)(firstObject) !== 'object' || (0, _typeof2.default)(obj) !== 'object') {
      return false;
    }
    var objKeys = obj && Object.keys(obj);
    return obj && objKeys.length === Object.keys(firstObject).length && objKeys.every(function (key) {
      return obj[key] === firstObject[key];
    });
  });
}
//# sourceMappingURL=objects.js.map